import { sdkFactory as wixFormsV4SpamSubmission_sdkFactory_spamSubmissions } from './src/forms-v4-spam-submission.frontend';
import { sdkFactory as wixInterfacesFormsV4SubmissionExtension_sdkFactory_submissionsExtensionSpi } from './src/interfaces-forms-v4-submission-extension.frontend';
import { sdkFactory as wixFormsV4FormSpamSubmissionReport_sdkFactory_formSpamSubmissionReports } from './src/forms-v4-form-spam-submission-report.frontend';
import { sdkFactory as wixFormsV4Submission_sdkFactory_submissions } from './src/forms-v4-submission.frontend';
export function sdkFactory(args) {
    return {
        spamSubmissions: wixFormsV4SpamSubmission_sdkFactory_spamSubmissions(args),
        submissionsExtensionSpi: wixInterfacesFormsV4SubmissionExtension_sdkFactory_submissionsExtensionSpi(args),
        formSpamSubmissionReports: wixFormsV4FormSpamSubmissionReport_sdkFactory_formSpamSubmissionReports(args),
        submissions: wixFormsV4Submission_sdkFactory_submissions(args),
    };
}
//# sourceMappingURL=index.frontend.js.map